// extracted by mini-css-extract-plugin
module.exports = {"droppable":"Layout-module--droppable--1mMWU","draggable":"Layout-module--draggable--Iuihk"};